import React from 'react';

const CompletedStepIcon = ({ className = "me-2", ...props }) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" className={className} viewBox="0 0 16 16" aria-hidden="true" focusable="false" role="img" {...props}>
        <title>Completado</title>
        <circle cx="8" cy="8" r="8" fill="#01844B" />
        <path d="M10.97 4.97a.75.75 0 0 1 1.07 1.05l-3.99 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425a.267.267 0 0 1 .02-.022z" fill="#FFFFFF" />
    </svg>
);

export default CompletedStepIcon;